import { onAuthStateChanged } from "firebase/auth";
import { createContext, useEffect, useState } from "react";

import { auth } from "../../../BackEnd/Firebase/Config";

export const AuthContext = createContext();
 
const AuthContextProvider = ({children}) => {
    const [currentUser , setCurrentUser] = useState({"loading" : true}) 

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth , (user) => {
            setCurrentUser(user);
        }) 
        return () => {
            unsubscribe()
        }
    },[currentUser])

    return (
        <AuthContext.Provider value={{currentUser}} >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider;